module.exports = __webpack_public_path__ + "img/archi2Shadow.e4b38ce3.png";